module.exports = __webpack_public_path__ + "img/book-green.4b5ad246.svg";